
namespace GeniuzPOS.InventoryReport {

    @Serenity.Decorators.registerClass()
    export class IcReport08DtDialog extends Serenity.EntityDialog<IcReport08DtRow, any> {
        protected getFormKey() { return IcReport08DtForm.formKey; }
        protected getIdProperty() { return IcReport08DtRow.idProperty; }
        protected getLocalTextPrefix() { return IcReport08DtRow.localTextPrefix; }
        protected getNameProperty() { return IcReport08DtRow.nameProperty; }
        protected getService() { return IcReport08DtService.baseUrl; }
        protected getDeletePermission() { return IcReport08DtRow.deletePermission; }
        protected getInsertPermission() { return IcReport08DtRow.insertPermission; }
        protected getUpdatePermission() { return IcReport08DtRow.updatePermission; }

        protected form = new IcReport08DtForm(this.idPrefix);

    }
}